import { FieldRegistration } from '../fieldRegistry';
import {
  extractTextValue,
  createTextUpdateHandler,
  resolveTextPlaceholder,
  createTextSerializer,
  createTextStoreSerializer,
  provideEmptyContext,
  validateTextField
} from '../fieldUtils';
import { renderTitleField } from './titleFieldRenderer';

export const titleFieldConfig: FieldRegistration = {
  renderer: renderTitleField,
  extractor: extractTextValue,
  updateHandler: createTextUpdateHandler(),
  placeholderResolver: resolveTextPlaceholder,
  apiSerializer: createTextSerializer(false),
  storeSerializer: createTextStoreSerializer(),
  contextProvider: provideEmptyContext,
  validator: validateTextField
};
